import { useState } from "react";
import { projects, workList } from "../data.js";
import { localizeField } from "../i18n.js";
import PostRow from "./PostRow.jsx";

const PROJECT_FILTERS = ["React", "Java", "JavaScript", "AI", "Python", "Cloud", "Chrome", "C++"];
const FILTER_ALIASES = {
  AI: ["ai", "gemini api", "opencv", "yolov8"],
  "C++": ["c++", "c++/cli"],
  Chrome: ["chrome", "chrome extensions api"],
  Cloud: ["cloud"],
  Java: ["java", "java spring boot"],
  JavaScript: ["javascript"],
};

export default function WorkPage({ t, copy, language }) {
  const [seeAll, setSeeAll] = useState(false);
  const [activeFilter, setActiveFilter] = useState("all");
  const sortedWork = [...workList].sort((a, b) => {
    if (!a.year) return 1;
    if (!b.year) return -1;
    return Number(b.year) - Number(a.year);
  });
  const filteredWork =
    activeFilter === "all"
      ? sortedWork
      : sortedWork.filter((item) => projectMatchesFilter(item, activeFilter));
  const visibleWork = activeFilter === "all" && !seeAll ? filteredWork.slice(0, 3) : filteredWork;

  return (
    <div>
      <h2 style={{ fontSize: 20, fontWeight: 400, marginBottom: 18 }}>{copy.projects}</h2>

      <div aria-label={copy.projectFilters} style={filterRowStyle}>
        {[copy.projectFilterAll, ...PROJECT_FILTERS].map((filter) => {
          const value = filter === copy.projectFilterAll ? "all" : filter;
          const isActive = activeFilter === value;

          return (
            <button
              key={filter}
              type="button"
              onClick={() => {
                setActiveFilter(value);
                setSeeAll(false);
              }}
              style={filterButtonStyle(t, isActive)}
            >
              {filter}
            </button>
          );
        })}
      </div>

      <div>
        {visibleWork.map((item, i) => (
          <PostRow
            key={item.id}
            root="projects"
            path={item.id}
            label={item.year}
            title={localizeField(item, "title", language)}
            subtitle={localizeField(item, "subtitle", language)}
            isFirst={i === 0}
            link={true}
            t={t}
            copy={copy}
          />
        ))}
        {visibleWork.length === 0 && (
          <p style={{ color: t.dim, fontSize: 14, margin: "18px 0 0" }}>
            {copy.projectFilterEmpty}
          </p>
        )}
        {activeFilter === "all" && sortedWork.length > 3 && (
          <button
            type="button"
            onClick={() => setSeeAll((value) => !value)}
            style={{
              marginTop: 10,
              padding: 0,
              border: 0,
              background: "transparent",
              font: "inherit",
              fontSize: 14,
              color: t.dim,
              cursor: "pointer",
            }}
          >
            {seeAll ? (
                copy.seeLess
              ) : (
                <>
                  {copy.seeAllGithubPrefix}{" "}
                  <a href="https://github.com/hamza-ouabiba" target="_blank" rel="noreferrer" style={{color: t.link}}>
                    GitHub
                  </a>
                  {copy.seeAllGithubSuffix}
                </>
            )}
          </button>
        )}
      </div>
    </div>
  );
}

function projectMatchesFilter(item, filter) {
  const project = projects[item.id];
  const tokens = getProjectFilterTokens(item, project);
  const aliases = FILTER_ALIASES[filter] || [filter.toLowerCase()];

  return aliases.some((alias) => tokens.has(alias.toLowerCase()));
}

function getProjectFilterTokens(item, project) {
  const values = [
    item.subtitle,
    item.subtitleFr,
    ...(project?.technologies || []),
  ].filter(Boolean);
  const tokens = new Set();

  values.forEach((value) => {
    const normalized = value.toLowerCase().trim();
    tokens.add(normalized);

    normalized
      .split(",")
      .map((part) => part.trim())
      .filter(Boolean)
      .forEach((part) => {
        tokens.add(part);
        part
          .split(/\s+/)
          .map((word) => word.trim())
          .filter(Boolean)
          .forEach((word) => tokens.add(word));
      });
  });

  return tokens;
}

const filterRowStyle = {
  display: "flex",
  flexWrap: "wrap",
  gap: 8,
  marginBottom: 20,
};

function filterButtonStyle(t, isActive) {
  return {
    background: isActive ? t.surface2 : "transparent",
    border: `1px solid ${isActive ? t.link : t.border}`,
    borderRadius: 8,
    color: isActive ? t.text : t.dim,
    cursor: "pointer",
    fontFamily: "'JetBrains Mono', monospace",
    fontSize: 12,
    padding: "6px 9px",
  };
}
